<template>
  <div class="mt-3">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-5 mt-4 text-white">
          <h1 v-if="nickname !== ''">Ahoy {{userBadge}} <br> {{nickname}}!</h1>
          <h1 v-else>Ahoy!</h1>

          <figure class="logo-main"><img src="../assets/fleet-battle-logoNew1-512.png" alt="Fleet Battle logo"></figure>


          <h3 class="mb-5">Welcome to Fleet Battle Global Leaderboard</h3>
          <hr>
          <div v-if="userRank > 0">
            <h3>You are currently </h3>
            <h1 class="pos" v-bind:class="{ posfirst: userRank == 1 }">{{userRank}}{{userRankExt}}</h1>
            <p class="lead mt-3">on the Global Leaderboard </p>
            <h2 class="pos" v-if="userRank == 1">Congratulations!</h2>
          </div>
          
          <p class="mt-3" v-if="userRank === 0 && nickname !== ''">Unfortunately your score doesn't qualify to Top 100 Players. Play more to earn more points!</p>
          <p class="mt-3" v-if="userRank === 0">Ask your voice assistant - Alexa or Google Assistant - about this leaderboard. You'll receive a nickname and after every game you'll earn points.</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 bg-white pt-3 mb-5">
          <h2>Top 100 Players</h2>
          <b-table striped responsive hover :items="pointsDbComp" :fields="fields">
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
          </b-table>
        </div>
      </div>
      <div class="row mt-3">

        <div class="col-12 col-md-6 mb-3">
          <div class="card">
            <div class="card-body  text-center">
              <img class="logo-provider" src="../assets/google-assistant.png" alt="Google Assistant logo">
              <h3>Play with Google Assistant</h3>
              <p>Click the link below or simply say "Hey Google, open Fleet Battle"</p>
              <a href="https://assistant.google.com/services/a/uid/0000007d2d11f9c1" class="btn btn-warning btn-lg">Fleet Battle on Google Assistant</a>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <div class="card">
            <div class="card-body text-center">
              <img class="logo-provider" src="../assets/alexa.png" alt="Amazon Alexa logo">
              <h3>Play with Alexa</h3>
              <p>Click the link below for US and UK version of Alexa Skill. Or simply say "Alexa, open Fleet Battle"</p>
              <a href="https://www.amazon.com/Fleet-Battle-Paper-Battleship-game/dp/B08B59ZDTJ/" class="btn btn-warning btn-lg mr-3 mb-3">Fleet Battle US</a><br>
              <a href="https://www.amazon.co.uk/Fleet-Battle-Paper-Battleship-game/dp/B08B59ZDTJ/" class="btn btn-warning btn-lg">Fleet Battle UK</a>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 mb-3">
          <div class="card">
            <div class="card-body">
              <h3>What is Fleet Battle?</h3>
              <p>This classic pen and paper game can now be played with Alexa. Alexa uses sophisticated Artificial Intelligence algorithms to shoot your ships just like another human player! </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 mb-3">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-6">
                  <h3>Where can I find the gameboard?</h3>
                  <p>You will be instructed how to draw the ocean grids yourself when you start the game! But if you want to save some time, here you can download and print them. Don't forget to draw your ships!</p>
                  <a href="/print/FleetBattle-GoogleAssistant-gameboard-instructions.pdf" target="_blank">
                    <figure class="image mt-5 mb-2"><img src="../assets/print-pdfs.jpg" alt="Fleet Battle gameboards"></figure>
                  </a>
                  
                </div>
                <div class="col-12 col-md-6">
                  <a href="/print/FleetBattle-GoogleAssistant-gameboard.pdf" target="_blank" class="btn btn-warning btn-lg mr-3 mb-3">Download Gameboards PDF</a><br>
                  <a href="/print/FleetBattle-GoogleAssistant-gameboard-instructions.pdf" target="_blank" class="btn btn-warning btn-lg">Gameboards and Instructions PDF</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-md-12 mb-5 mt-5 text-white text-center">
          <h3>Looking for more games?</h3>
          <a href="https://veeheister.com" class="btn btn-warning btn-lg">See other games and apps we made</a>
        </div>
      </div>


      <footer class="footer text-white mt-5 border-top pt-5">
        <div class="row footer-content">
          <div class="col-12 col-sm-6 order-3">
            <p><small>© 2020 Veeheister Ltd. All right reserved. Google, Google Assistant, Amazon, Alexa are registered trademarks and property of their respective
                owners.</small></p>
          </div>
          <div class="col-12 col-sm-6 order-2 order-md-12">
            <div class="d-flex justify-content-md-end">
              <ul class="list-inline">
                <li class="list-inline-item"><a href="https://veeheister.com/" class="link nuxt-link-exact-active nuxt-link-active">Veeheister Ltd</a>
                </li>
                <li class="list-inline-item"><a href="https://veeheister.com/privacy-policy" class="link">Privacy Policy</a></li>
                <li class="list-inline-item"><a href="https://veeheister.com/terms-and-conditions" class="link">Terms and Conditions</a></li>
                <li class="list-inline-item"><a href="https://www.linkedin.com/company/veeheister" target="_blank" class="link">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { db } from '@/db'

export default {
  name: 'Homepage',
    data () {
      return {
        nickname: '',
        userBadge: 'Captain',
        userRank: 0,
        userRankExt: 'th',
        fields: [
          {
            key: 'index',
            label: 'Pos'
          },
          {
            key: 'nickname'
          },
          {
            key: 'points',
            label: 'Points'
          },
          {
            key: 'win',
            label: 'Wins'
          },
          {
            key: 'loss',
            label: 'Losses'
          },
          {
            key: 'gamesPlayed',
            label: 'Games'
          }
        ],

        pointsDb: [],
      }
    },
    mounted () {
      console.log(this.$route.query.n);
      this.nickname = this.$route.query.n || '';
    },
    computed: {
      pointsDbComp () {
        var arr = this.pointsDb;
        if (arr.length !== 0) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].nickname === this.nickname) {
              arr[i]._rowVariant = 'success';
            }
          }
        }
        return this.pointsDb;
      }
    },
    methods: {
      love() {
        this.$confetti.update({
          particles: [
            {
              type: 'heart',
            },
            {
              type: 'circle',
            },
          ],
          defaultColors: [
            'red',
            'pink',
            '#ba0000'
          ],
        });
      }
    },
    watch: {
      pointsDbComp () {
        var arr = this.pointsDbComp;
        if (arr.length !== 0) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].nickname === this.nickname) {
              this.userRank = i + 1;
              if (this.userRank === 1) {
                this.userBadge = "Admiral";
                this.$confetti.start();
                var self = this;
                setTimeout(function() { 
                  self.$confetti.stop();
                  }, 10000);
              }
              // Determine extension 
              var rankString = this.userRank.toString();
              var lastChar = rankString[rankString.length -1];
              if (lastChar === '1') {
                this.userRankExt = "st";
              } else if (lastChar === '2') {
                this.userRankExt = "nd";
              } else if (lastChar === '3') {
                this.userRankExt = "rd";
              } else {
                this.userRankExt = "th";
              }
            }
          }
        }
        return this.pointsDb;
      }
    },
    firestore () {
      return {
        pointsDb: db.collection('premiumScoreFive').orderBy("points", "desc").limit(100)
      }
    }
}
</script>

<style lang="scss">
#app {
  overflow-x: hidden;
  
}

#app.bg-white {
  background-color: #0d2f6b !important;
}
body {
  background-color: #0d2f6b !important;
}

.table td:nth-child(2) {
  width: 250px !important;
  white-space: nowrap;
}

.table td:nth-child(3) {
  font-size: 18px;
  font-weight: 600;
  font-family: 'Roboto Mono', monospace;
}

h1, h2, h3, h4 {
  font-family: 'Roboto Mono', monospace;
}
.logo-alexa {
  max-width: 300px;
}
.logo-main {
  display: block;
  width:200px;
  height: 200px;
  border-radius: 150px;
  overflow: hidden;
  margin: 30px auto;
  border: 3px solid #fff;
  box-shadow: 0 5px 5px rgba(0,0,0,0.5);
  img {
    width: 100%;
  }
}

.btn {
  font-family: 'Roboto Mono', monospace;
  font-weight: 500 !important;
}

.logo-provider {
  max-width: 150px;
  margin-bottom: 20px;
}

.image {
  width: 100%;
  img {
    display: block;
    width: 100%;  
  }
}

hr {
  background: #fff;
}

.posfirst {
  font-size: 60px;
  animation: pulse 0.5s alternate infinite ease-in;
}

@keyframes pulse {
  0%   {transform: scale(.9);}
  100% {transform: scale(1.1);}
}
</style>
